import { TFunction } from 'i18next'
import { Action } from '../../../Table/RowActions'
import { Payment } from '../../../Interfaces/Payment'

export type HandleMoreInfo = (
  paymentMethod: string,
  date: Date,
  status: string,
  amount: string,
  orderId: string,
  parentKey: number,
  studentNames: string[]
) => void

export interface GetLcdLicensingPaymentHistoryRowActions {
  t: TFunction
  handleEdit: (payment: Payment) => void
  canEditPayments: boolean
  handleMoreInfo: HandleMoreInfo
  userKey?: number
}

export const getLcdLicensingPaymentHistoryRowActions = ({
  t,
  handleEdit,
  canEditPayments,
  handleMoreInfo,
  userKey,
}: GetLcdLicensingPaymentHistoryRowActions): Action<Payment>[] => {
  const rowActions: Action<Payment>[] = [
    {
      actionName: t('LcdLicensingPaymentHistory.RowAction.Edit', 'Edit'),
      actionKey: 'edit',
      actionFunction: (payment) => handleEdit(payment),
      hide: (row) =>
        !canEditPayments || (!!userKey && row?.userKey === userKey),
    },
    {
      actionName: t(
        'Billing.BillingHistorySummaryTable.RowAction.MoreInfo',
        'More Info'
      ),
      actionKey: 'moreInfo',
      actionFunction: (record) => {
        handleMoreInfo(
          record.paymentMethodKey,
          record.begunAt,
          record.paymentStatusKey,
          record.total?.amount.toString() ?? '',
          record.orderId ?? '',
          record.userKey,
          record.enrollmentPayments?.map(
            (enrollmentPayment) => enrollmentPayment?.studentFirstName as string
          ) ?? []
        )
      },
      hide: () => canEditPayments,
    },
  ]

  return rowActions
}
